import React, { PureComponent } from 'react';
import moment from 'moment';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import find from 'lodash/find';
import Text, { H1, Large } from '@dbk/ui-text';
import BlurModal from '../../../components/common/blur-modal';
import BackLink from '../../../components/common/back-link';
import Responsive from '../../../components/common/responsive-dimension-values';
import { Message } from '@dbk/ui-forms';

import Grid, { Cell } from '@dbk/ui-grid';
import { DOC_STATUS_MAPPING, DOC_MANAGE_ACTIONS, DATE_FORMATS, DOC_STATUS_VALIDATIONS } from '../../../constants';
import getOr from 'lodash/fp/getOr';
import { LoadingCircle } from '../../../components/common/loading';

const DOC_DETAILS_ADMIN = [
  [
    { Value: 'document_name', Label: 'app.docsigncenter.uploadDoc.documentName.label' },
    { Value: 'template_name', Label: 'app.docsigncenter.uploadDoc.documentType.label' },
  ],
  [
    { Value: 'order_id', Label: 'app.docsigncenter.uploadDoc.orderId.label' },
    { Value: 'status_for_rm', Label: 'app.docsigncenter.status' }
  ],
  [
    { Value: 'start_date', Label: 'app.docsigncenter.uploadDate' },
    { Value: 'client_sign_date', Label: 'app.docsigncenter.signedDate' },
  ],
  [
    { Value: 'pf_id', Label: 'app.docsigncenter.uploadDoc.portfolioId.label' },
    { Value: 'name', Label: 'app.docsigncenter.uploadDoc.userName.label' }
  ],
  [
    { Value: 'rmName', Label: 'app.docsigncenter.uploadDoc.rm.name' },
    { Value: 'rmTeam', Label: 'app.docsigncenter.uploadDoc.rm.team' }
  ],
  [
    { Value: 'rm_message', Label: 'app.docsigncenter.uploadDoc.rm.message' },
    {}
  ]  
];


function getValueByIndex(rowIndex, columnIndex) {
  return DOC_DETAILS_ADMIN[rowIndex][columnIndex].Value;
}

function renderDataCell({ rowIndex, columnIndex, docDetails }) {
  const val = getValueByIndex(rowIndex, columnIndex);
  if (val === "start_date") {
    return moment(docDetails[val]).format(DATE_FORMATS.displayDate);
  }
  if (val === "client_sign_date") {
    if (DOC_STATUS_VALIDATIONS.hideTargetDateTime.indexOf(docDetails.document_status) === -1) {
      return moment(docDetails[val]).format(DATE_FORMATS.displayDateAndTime);
    }
    return '-';
  }
  return docDetails[val];
}


function getCellStyle(row, column, curStatus) {
  let curStyle = "cell-container ";
  if (row === 1 && column === 1) {
    if (find(DOC_STATUS_MAPPING, { status: curStatus })) {
      const statusStyle = find(DOC_STATUS_MAPPING, { status: curStatus }).colorClass;
      curStyle += statusStyle;
    }
  }
  return curStyle;
}

class DocDetails extends PureComponent {
  constructor(props) {
    super(props);

    const currentLocation = window.location.pathname;
    const docId = currentLocation.split('/')[4] || currentLocation.split('/')[3];
    const documentDetails = find(this.props.docsigncenter.documentListForAdmin.documentListResponse, { dwo_doc_sid: parseInt(docId, 10) });

    this.state = {
      downloadLoading: false,
      showModal: false,
      documentDetails,
      docRejectModal: false,
      docAcceptModal: false,
      acknowledgeModal: false,
      docPullbackModal: false,
      currentAcknowledgeAction: '',
      downloadStatus: {
        isFailed: false,
        message: ''
      }
    }

    this.pressedConfirm = this.pressedConfirm.bind(this);
    this.pressedCancel = this.pressedCancel.bind(this);
    this.handleDownloadDocument = this.handleDownloadDocument.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleConfirmationModal = this.handleConfirmationModal.bind(this);
    this.handleConfirmAction = this.handleConfirmAction.bind(this);
    this.handleAcknowledgeModal = this.handleAcknowledgeModal.bind(this);
  }


  componentDidUpdate(prevProps, prevState) {
    const { i18n: { messages }, docsigncenter: { userDocumentStatus, downloadCompleteStatus } } = this.props;
    if (prevProps.docsigncenter.userDocumentStatus !== userDocumentStatus && userDocumentStatus !== undefined) {
      if (userDocumentStatus === true) {
        this.setState({
          acknowledgeModal: true,
          showLoading: false
        });
      } else {
        const errMessage = userDocumentStatus === "error" ? messages['app.digisign.error.tryagain'] : userDocumentStatus;
        alert(errMessage);
      }

      this.props.getResetUserDocumentStatus();
    }

    if (prevProps.docsigncenter.downloadCompleteStatus !== downloadCompleteStatus && downloadCompleteStatus !== undefined) {
      if (downloadCompleteStatus === true) {
        this.setState({
          downloadLoading: false
        });
      } else {
        this.setState({
          downloadLoading: false,
          downloadStatus: {
            isFailed: true,
            message: downloadCompleteStatus === "error" ? messages['app.digisign.error.tryagain'] : downloadCompleteStatus
          }
        });
      }
    }

  }

  rowHeight = ({ index }) => (index === 0 ? 80 : 80);

  columnWidth({ index }) {

    // const maxColumnWidth = 805; //725;
    // const calcColWidth = Responsive.windowWidth * 0.9 / 2;

    // const columnWidth = calcColWidth >= maxColumnWidth ? maxColumnWidth : calcColWidth;

    // return getOr(725, index, [columnWidth, columnWidth]);

    return '50%';

  };




  renderCell = ({ rowIndex, columnIndex, gridRowIndex, gridColumnIndex }) => {
    const {
      i18n: { messages },
    } = this.props;
    const { documentDetails } = this.state;

    const headerLabel = messages[DOC_DETAILS_ADMIN[rowIndex][columnIndex].Label];
    return (
      <div className="cell-div">
        <div>
          <Large className="docdetails-summary-index">{headerLabel}</Large>
        </div>
        <div>
          <Cell {...{ gridRowIndex, gridColumnIndex }}
            className={getCellStyle(rowIndex, columnIndex, documentDetails.document_status)}>
            {renderDataCell({ rowIndex, columnIndex, docDetails: documentDetails })}
          </Cell>
        </div>
      </div>
    );
  };

  goBack() {
    this.props.changePage('/docsigncenter');
  }

  handleConfirmAction(actionSelected) {
    switch (actionSelected) {
      case DOC_MANAGE_ACTIONS.verify: {
        this.setState({ docAcceptModal: true });
        break;
      }
      case DOC_MANAGE_ACTIONS.reject: {
        this.setState({ docRejectModal: true });
        break;
      }
      case DOC_MANAGE_ACTIONS.pullback: {
        this.setState({ docPullbackModal: true });
        break;
      }
      default: break;
    }
  }

  handleConfirmationModal(actionSelected) {
    const { i18n: { messages } } = this.props;
    const { documentDetails } = this.state;

    let headingId = '';
    switch (actionSelected) {
      case DOC_MANAGE_ACTIONS.verify: {
        headingId = 'app.docsigncenter.docdetails.blurmodal.verify.heading.1';
        break;
      }
      case DOC_MANAGE_ACTIONS.reject: {
        headingId = 'app.docsigncenter.docdetails.blurmodal.reject.heading.1';
        break;
      }
      case DOC_MANAGE_ACTIONS.pullback: {
        headingId = 'app.docsigncenter.docdetails.blurmodal.pullback.heading.1';
        break;
      }
      default: break;
    }


    return (
      <div>
        <div><Text secondary>{messages[headingId]}</Text>{' '}{documentDetails.document_name}
          <Text secondary>{messages['app.docsigncenter.docdetails.blurmodal.heading.2']}</Text>{' '}{documentDetails.name}?
        </div>
        <div className="row pad-top-100 small-offset-1 timeout-modal">
          <div className="columns small-1 small-offset-5">
            <Button tertiary testID="docdetails-confirmation-cancel"
              onClick={() => this.pressedCancel()}
            >
              {messages['app.profile.changeLanguage.cancelText']}
            </Button>
          </div>
          <div className="columns small-4 small-offset-2">
            <Button testID="docdetails-confirmation-confirm"
              onClick={() => this.pressedConfirm(actionSelected)}
            >
              {messages['app.common.alert.yes']}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  handleAcknowledgeModal(actionSelected) {
    const { i18n: { messages } } = this.props;

    let messageId = '';
    switch (actionSelected) {
      case DOC_MANAGE_ACTIONS.verify: {
        messageId = 'app.docsigncenter.docdetails.blurmodal.verify.confirmation';
        break;
      }
      case DOC_MANAGE_ACTIONS.reject: {
        messageId = 'app.docsigncenter.docdetails.blurmodal.reject.confirmation';
        break;
      }
      case DOC_MANAGE_ACTIONS.pullback: {
        messageId = 'app.docsigncenter.docdetails.blurmodal.pullback.confirmation';
        break;
      }
      default: break;
    }


    return (
      <div>
        <div><Text secondary testID="docDetails-acknowledgement-text">{messages[messageId]}</Text></div>
        <div className="row">
          <div className="btn timeout-modal">
            <Button
              testID="docDetails-acknowledgement-ok"
              onClick={() => this.goBack()}>
              {messages["app.rmcallback.okMsg"]}
            </Button>
          </div>
        </div>
      </div>
    );
  }



  pressedCancel() {
    this.setState({ docRejectModal: false, docAcceptModal: false, docPullbackModal: false });
  }


  pressedConfirm(selectedAction) {
    const docId = this.state.documentDetails.dwo_doc_sid;
    const pfId = this.state.documentDetails.pf_id;
    const branchCode = this.state.documentDetails.branch_code;

    this.setState({
      docRejectModal: false,
      docAcceptModal: false,
      docPullbackModal: false,
      currentAcknowledgeAction: selectedAction,
      showLoading: true
    });
    this.props.getManageUserDocument(docId, selectedAction, pfId, branchCode);
  }
  handleDownloadDocument(e) {
    this.setState({
      downloadLoading: true,
      downloadStatus: {
        isFailed: false,
        message: ''
      }
    });

    let docId = "";
    if (DOC_STATUS_VALIDATIONS.downloadStampedDoc.indexOf(this.state.documentDetails.document_status) !== -1) {
      docId = this.state.documentDetails.dms_signed_doc_id;
    } else {
      docId = this.state.documentDetails.dms_doc_id;
    }

    this.props.docsigncenter.downloadDocument(docId, this.state.documentDetails.document_name);
  }


  render() {
    const { i18n: { messages },
      auth: { isAdminUser } } = this.props;

    const showAcceptVerify = DOC_STATUS_VALIDATIONS.showAcceptVerify.indexOf(this.state.documentDetails.document_status) !== -1 && isAdminUser;
    const showPullBack = DOC_STATUS_VALIDATIONS.showPullBack.indexOf(this.state.documentDetails.document_status) !== -1;

    return (
      <div className="doc-details">
        {isAdminUser &&
          <div className="portfolio-row doc-back-link">
            <div className="text-left">
              <BackLink messages={messages} />
            </div>
          </div>
        }

        {this.state.showLoading ?
          <LoadingCircle />
          :

          <div>
            <div testID="docDetails-heading" className="margin-bottom-30 docDetails-header">
              {messages['app.docsigncenter.docdetails']}
            </div>

            <div className="detailGrid-container">
              <Grid
                classNameMain="detailGridMain"
                rowCount={DOC_DETAILS_ADMIN.length}
                columnCount={DOC_DETAILS_ADMIN[0].length}
                rowHeight={this.rowHeight}
                columnWidth={this.columnWidth}
                renderCell={this.renderCell}
              />

              <div className="row margin-left-25">
              {showAcceptVerify &&
                   <div className="btn">
                    <Button testID="doc-details-verify" size="large" onClick={() => this.handleConfirmAction(DOC_MANAGE_ACTIONS.verify)} >
                      {messages["app.docsigncenter.docdetails.verify"]}
                    </Button>
                  </div>
                }
                {showAcceptVerify &&
                  <div className="btn">
                    <Button secondary testID="doc-details-reject" size="large" onClick={() => this.handleConfirmAction(DOC_MANAGE_ACTIONS.reject)} >
                      {messages["app.docsigncenter.docdetails.reject"]}
                    </Button>
                  </div>
                }
                {showPullBack &&
                  <div className="btn">
                    <Button testID="doc-details-pullback" size="large" onClick={() => this.handleConfirmAction(DOC_MANAGE_ACTIONS.pullback)} >
                      {messages["app.docsigncenter.docdetails.pullback"]}
                    </Button>
                  </div>
                }
                <div className="btn">
                  <Button
                    tertiary testID="doc-details-viewDocument" size="large" onClick={(e) => this.handleDownloadDocument(e)}
                    loading={this.state.downloadLoading ? true : false}>
                    {messages["app.docsigncenter.docdetails.viewDocument"]}
                  </Button>
                </div>
                <div className="btn">
                  <Message testID="docSignCenter-modal-container-submit-error" type="error">
                    {this.state.downloadStatus.isFailed && this.state.downloadStatus.message}
                  </Message>
                </div>

              </div>
            </div>
          </div>}
        {this.state.docRejectModal &&
          <BlurModal
            hasHeader
            title={messages["app.docsigncenter.docdetails.blurmodal.reject.title"]}
            visible={this.state.docRejectModal}
            doneVisible
            doneLabel={messages["app.common.closeText"]}
            onDone={this.pressedCancel}
          >
            {this.handleConfirmationModal(DOC_MANAGE_ACTIONS.reject)}
          </BlurModal>
        }
        {this.state.docAcceptModal &&
          <BlurModal
            hasHeader
            title={messages["app.docsigncenter.docdetails.blurmodal.accept.title"]}
            visible={this.state.docAcceptModal}
            doneVisible
            doneLabel={messages["app.common.closeText"]}
            onDone={this.pressedCancel}
          >
            {this.handleConfirmationModal(DOC_MANAGE_ACTIONS.verify)}
          </BlurModal>
        }
        {this.state.docPullbackModal &&
          <BlurModal
            hasHeader
            title={messages["app.docsigncenter.docdetails.blurmodal.pullback.title"]}
            visible={this.state.docPullbackModal}
            doneVisible
            doneLabel={messages["app.common.closeText"]}
            onDone={this.pressedCancel}
          >
            {this.handleConfirmationModal(DOC_MANAGE_ACTIONS.pullback)}
          </BlurModal>
        }


        {this.state.acknowledgeModal &&
          <BlurModal
            hasHeader
            title={messages["app.docsigncenter.docdetails.blurmodal.acknowledge.title"]}
            visible={this.state.acknowledgeModal}
            doneVisible
            onDone={this.goBack}
          >
            {this.handleAcknowledgeModal(this.state.currentAcknowledgeAction)}
          </BlurModal>
        }
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getManageUserDocument: { $call: 'docsigncenter.manageUserDocument' },
    getResetUserDocumentStatus: { $call: 'docsigncenter.resetUserDocumentStatus' },
    docsigncenter: {
      documentListForAdmin: true,
      downloadDocument: {
        $call: 'viewDocumentForAdmin',
      },
      userDocumentStatus: true,
      downloadCompleteStatus: true
    },
    auth: {
      isAdminUser: true
    }
  }
})(DocDetails);

export { DocDetails };